"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsCalendar = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
const react_1 = __importStar(require("react"));
const react_dates_1 = require("react-dates");
const moment_1 = __importDefault(require("moment"));
const className_1 = require("../../utils/className");
const Header_1 = __importDefault(require("./Header"));
const DatePickerWrapper_1 = __importDefault(require("./DatePickerWrapper"));
const Button_1 = __importDefault(require("./Button"));
const PrevIcon_1 = __importDefault(require("./PrevIcon"));
const NextIcon_1 = __importDefault(require("./NextIcon"));
const InfoPanel_1 = __importDefault(require("./InfoPanel"));
require("react-dates/initialize");
exports.SmlsCalendar = ({ id, idConfirmButton = 'btn_confirmCalendar', idNextIconButton = 'btn_nextCalendar', idPrevIconButton = 'btn_prevCalendar', idErrorMessage = 'lbl_msgInvalid_', disabled = false, anchorDirection = 'right', onChange = () => undefined, startDateInitialValue, endDateInitialValue, startDateValue, endDateValue, displayFormat = 'ddd, DD MMM', initialDatesPattern = 'YYYY-MM-DD', startDateId, endDateId, startDatePlaceholderText = 'Check In', endDatePlaceholderText = 'Check Out', mobilePlaceholderText, datesListHighlight = [], numberOfMonths = 2, errorMessage, isSingleDate = false, singleDateTitleHeader = 'Data da viagem', minimumNights = 1, daysHoverText, forceError = false, forceFocus, numberOfVerticalMonths, disableScroll = false, readOnly = true, minDate = 1, maxDate = 24, isOutsideRange, renderDayContents, renderMonthElement, }) => {
    const inputRef = react_1.useRef(null);
    const [focusedInput, setFocusedInput] = react_1.useState(null);
    const [startDate, setStartDate] = react_1.useState(null);
    const [endDate, setEndDate] = react_1.useState(null);
    const [selectedMoment, setSelectedMoment] = react_1.useState(moment_1.default().startOf('month'));
    const [visibleMonths, setVisibleMonths] = react_1.useState([]);
    const [isMobile, setIsMobile] = react_1.useState(false);
    const [isMobileOpenSelector, setIsMobileOpenSelector] = react_1.useState(false);
    const [isValid, setIsValid] = react_1.useState(true);
    const [isValidSelectEndDate, setTooltipEnable] = react_1.useState(true);
    react_1.useEffect(() => {
        if ((visibleMonths === null || visibleMonths === void 0 ? void 0 : visibleMonths.length) > 0) {
            const min = visibleMonths.reduce((a, b) => (a.isAfter(b) ? b : a));
            setSelectedMoment(min);
        }
    }, [visibleMonths]);
    const displayStartDate = react_1.useMemo(() => {
        if (isSingleDate) {
            if (startDateValue) {
                return moment_1.default(startDateValue, initialDatesPattern);
            }
            if (!startDate && (startDateInitialValue === null || startDateInitialValue === void 0 ? void 0 : startDateInitialValue.length)) {
                return moment_1.default(startDateInitialValue, initialDatesPattern);
            }
            return null;
        }
        if (!startDate && (startDateInitialValue === null || startDateInitialValue === void 0 ? void 0 : startDateInitialValue.length)) {
            return moment_1.default(startDateInitialValue, initialDatesPattern);
        }
        return startDate;
    }, [startDate, startDateInitialValue]);
    const displayEndDate = react_1.useMemo(() => {
        if (isSingleDate)
            return null;
        if (!endDate && (endDateInitialValue === null || endDateInitialValue === void 0 ? void 0 : endDateInitialValue.length)) {
            return moment_1.default(endDateInitialValue, initialDatesPattern);
        }
        return endDate;
    }, [endDate, endDateInitialValue]);
    const onDatesChange = (onChangeProps) => {
        var _a, _b;
        setIsValid((((_a = onChangeProps.startDate) === null || _a === void 0 ? void 0 : _a.isValid()) && ((_b = onChangeProps.endDate) === null || _b === void 0 ? void 0 : _b.isValid())) ||
            false);
        setStartDate(onChangeProps.startDate);
        setEndDate(onChangeProps.endDate);
        if (onChangeProps.endDate !== endDate) {
            setFocusedInput('startDate');
        }
        if (onChange) {
            onChange({
                startDate: onChangeProps.startDate,
                endDate: onChangeProps.endDate,
            });
        }
    };
    const handleSubmit = () => {
        if (onChange)
            onChange({ startDate, endDate });
        setFocusedInput(null);
    };
    const handleOnFocusChange = react_1.useCallback((inputChange) => {
        if (isSingleDate && inputChange === 'endDate')
            return;
        if (!inputChange) {
            setFocusedInput(null);
            return;
        }
        setFocusedInput(inputChange);
    }, [isSingleDate]);
    const checkIsMobile = () => {
        if (window.innerWidth > 992)
            return setIsMobile(false);
        return setIsMobile(true);
    };
    const handleToggleIsModalSelector = (isOpen) => {
        setIsMobileOpenSelector(() => isOpen);
    };
    const onDateHover = (date) => {
        const dateIsSame = startDate === null || startDate === void 0 ? void 0 : startDate.isSame(date);
        setTooltipEnable(!dateIsSame);
    };
    react_1.useEffect(() => {
        window.addEventListener('resize', () => checkIsMobile());
        return window.removeEventListener('resize', () => checkIsMobile());
    }, []);
    react_1.useEffect(() => {
        checkIsMobile();
        moment_1.default.locale('pt-br');
    }, []);
    react_1.useEffect(() => {
        if (forceFocus) {
            setFocusedInput('startDate');
        }
    }, [forceFocus]);
    if (isMobile) {
        return (react_1.default.createElement("div", { id: id, ref: inputRef, className: className_1.mapToCssModules([
                'smls-calendar smls-calendar-mobile',
                disabled ? 'disabled' : '',
                isMobileOpenSelector ? 'open' : 'close',
            ]) },
            react_1.default.createElement(DatePickerWrapper_1.default, { onToggle: handleToggleIsModalSelector, startDate: displayStartDate, disabled: disabled, endDate: displayEndDate, displayFormat: displayFormat, numberOfVerticalMonths: numberOfVerticalMonths, onDatesChange: onDatesChange, isSingleDate: isSingleDate, singleDateTitleHeader: singleDateTitleHeader, minimumNights: minimumNights, isOpen: isMobileOpenSelector, forceFocus: forceFocus, isOutsideRange: isOutsideRange || undefined, datesListHighlight: datesListHighlight, startDatePlaceholderText: mobilePlaceholderText && !isMobileOpenSelector
                    ? mobilePlaceholderText
                    : startDatePlaceholderText, endDatePlaceholderText: isMobileOpenSelector ? endDatePlaceholderText : '', renderDayContents: renderDayContents, renderMonthElement: renderMonthElement }),
            react_1.default.createElement("div", { className: className_1.mapToCssModules([
                    'smls-input-data-backdrop',
                    isMobileOpenSelector ? 'open' : '',
                ]) })));
    }
    const prevIcon = () => {
        return (react_1.default.createElement(PrevIcon_1.default, { idPrevIconButton: idPrevIconButton, selectedMoment: selectedMoment, minDate: minDate }));
    };
    const nextIcon = () => {
        return (react_1.default.createElement(NextIcon_1.default, { idNextIconButton: idNextIconButton, selectedMoment: selectedMoment, maxDate: maxDate }));
    };
    return (react_1.default.createElement("div", { id: id, className: className_1.mapToCssModules([
            'smls-calendar',
            isSingleDate ? 'single-input' : '',
            disabled ? 'disabled' : '',
            (!isValid && !focusedInput && !isSingleDate) || forceError
                ? 'error-calendar-input'
                : '',
        ]) },
        react_1.default.createElement(react_dates_1.DateRangePicker, { isOutsideRange: isOutsideRange || undefined, startDateId: startDateId, endDateId: endDateId, onDatesChange: onDatesChange, onFocusChange: handleOnFocusChange, focusedInput: focusedInput, minimumNights: isSingleDate ? 0 : minimumNights, startDate: startDateValue
                ? moment_1.default(startDateValue, initialDatesPattern)
                : displayStartDate, endDate: isSingleDate ? null : displayEndDate, navPrev: prevIcon(), navNext: nextIcon(), showDefaultInputIcon: true, readOnly: readOnly, disableScroll: disableScroll, disabled: disabled, keepOpenOnDateSelect: true, inputIconPosition: "after", calendarInfoPosition: "bottom", customArrowIcon: react_1.default.createElement(Button_1.default, { type: "" }), customInputIcon: react_1.default.createElement(Button_1.default, { type: "calendar" }), renderDayContents: (day) => {
                if (renderDayContents)
                    return renderDayContents;
                if (!isValidSelectEndDate &&
                    focusedInput === 'endDate' &&
                    daysHoverText &&
                    daysHoverText.length > 0) {
                    return (react_1.default.createElement("span", { id: "lbl_notificationsCalendar", "data-title": daysHoverText, onMouseEnter: () => onDateHover(day) }, moment_1.default(day).format('D')));
                }
                return (react_1.default.createElement("span", { id: `date_${moment_1.default(day).format('DDMY')}`, onClick: (e) => {
                        if (focusedInput === 'startDate')
                            e.currentTarget.id = 'lbl_selectedDate_1';
                        if (focusedInput === 'endDate')
                            e.currentTarget.id = 'lbl_selectedDate_2';
                    }, onMouseEnter: () => onDateHover(day) }, moment_1.default(day).format('D')));
            }, verticalHeight: 1000, numberOfMonths: numberOfMonths, renderCalendarInfo: () => (react_1.default.createElement(InfoPanel_1.default, { idConfirmButton: idConfirmButton, onClick: handleSubmit, datesListHighlight: datesListHighlight, selectedDate: selectedMoment, disabledButton: isSingleDate && (startDate || startDateValue)
                    ? !isSingleDate
                    : !(startDate && endDate) })), anchorDirection: anchorDirection, transitionDuration: 200, minDate: moment_1.default().subtract(minDate, 'months').startOf('month'), maxDate: moment_1.default().add(maxDate, 'months').endOf('month'), renderMonthElement: (momentMonth) => {
                const temp = [...visibleMonths];
                let changed = false;
                const savedMonthIdx = temp.findIndex((elem) => elem.year() === momentMonth.month.year() &&
                    elem.month() === momentMonth.month.month());
                if (savedMonthIdx >= 0) {
                    if (!momentMonth.isVisible) {
                        temp.splice(savedMonthIdx, 1);
                        changed = true;
                    }
                }
                else if (momentMonth.isVisible) {
                    if (temp.length > 1) {
                        temp.shift();
                    }
                    temp.push(momentMonth.month);
                    changed = true;
                }
                if (changed) {
                    setVisibleMonths(temp);
                }
                if (renderMonthElement)
                    return renderMonthElement(momentMonth);
                return react_1.default.createElement(Header_1.default, { currentMoment: momentMonth.month });
            }, startDatePlaceholderText: startDatePlaceholderText, endDatePlaceholderText: endDatePlaceholderText, isDayHighlighted: (day1) => datesListHighlight.some((day2) => react_dates_1.isSameDay(day1, day2.date)), displayFormat: displayFormat, weekDayFormat: "ddd" }),
        react_1.default.createElement("div", { className: "input-error" }, errorMessage &&
            ((!isValid && !focusedInput && !isSingleDate) || forceError) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("i", { className: "material-icons notranslate" }, "\uE001"),
            react_1.default.createElement("label", { id: idErrorMessage, htmlFor: "input-text" }, errorMessage))))));
};
//# sourceMappingURL=index.js.map